module.exports = __webpack_public_path__ + "img/11.23cd3df8.svg";